import ListDocTemplates from "./ListDocTemplates";

export default ListDocTemplates;



// WEBPACK FOOTER //
// ./src/components/DocTemplates/index.js